import { getFunctionList } from '@/mixins';

export default {
  mixins: [getFunctionList],
  computed: {
    canListAttachment() {
      return this.functionList.includes('327747876754788352');
    },
    canDisableAttachment() {
      return this.functionList.includes('327749279665590272');
    },
    canAddAttachment() {
      return this.functionList.includes('327748500015779840');
    },
    canUpdateAttachment() {
      return this.functionList.includes('327748906619998208');
    },
    canDeleteAttachment() {
      return this.functionList.includes('327749053391278080');
    },
    canPreview() {
      return this.functionList.includes('327748319551655936');
    },
    readonly() {
      return !this.functionList.includes('326646093462605824');
    },
    canViewOrg() {
      return this.functionList.includes('326647415515615232');
    },
    // 是否有查看详情操作
    canViewDetail() {
      return this.functionList.includes('326644534192345088');
    },
    // 能否进行置顶操作
    canUpdateTop() {
      return this.functionList.includes('326645345123274752');
    },
    // 能否进行上下架操作
    canUpdateSale() {
      return this.functionList.includes('326645098221375488');
    },
    canUpdateDescription() {
      return this.functionList.includes('326646093462605824');
    },
    statusMap() {
      return this.depositPrdStatus.reduce((acc, item) => {
        acc[item.value] = item.label;
        return acc;
      }, {});
    },
  },

  mounted() {
    this.getDictValue('depositPrdStatus', 1);
    this.getDictValue('depositPrdTermLimit', 2);
  },

  methods: {
    getConfirmButtonClass(status) {
      if (status === '1') {
        return 'cds-button--red';
      }
      return 'cds-button--green';
    },
    getDictValue(name, order) {
      function formatDict(list) {
        return list.map(item => ({
          label: item.dictName,
          value: item.dictValue,
        }));
      }
      this.$_post(`${this.$API.selectDict}?v=${order}`, {
        data: {
          dictTypeCode: name,
        },
      }).then((res) => {
        this[name] = formatDict(res.data.list || []);
      });
    },
    handleDetailClick(detail) {
      this.addNav({
        path: '/cds-detail',
        query: {
          prdCode: detail.prdCode,
          prdName: detail.prdName,
        },
        name: '产品详情',
      });
    },
    // operation 何种操作 productName 产品名称 confirmAction 执行方法
    confirm(operation, productName, confirmAction) {
      return this.$_yh_confirm(`确定要${operation}"${productName}"?`, '提示', {
        confirmButtonText: operation,
      }).then(confirmAction);
    },
    formatter(row, col, value) {
      const needTransform = [
        'originBuyMoney',
        'perBuyMaxMoney',
        'onePerBuyMaxMoney',
        'saleAmt',
        'remainAmounts',
        'incrementalAmount',
      ];
      if (needTransform.includes(col.property)) {
        return this.getAlignRight(this.formatCurrency(value));
      }
      const needDateTransform = ['subStartDay', 'subEndDay'];
      if (needDateTransform.includes(col.property)) {
        return this.formatDate(value);
      }
      switch (col.property) {
        case 'prdCode':
          return this.getProductCodeText(value, row);
        case 'isTop':
          return this.getStickText(value);
        case 'isSale':
          return this.getSaleText(value);
        case 'saleStatus':
          return this.getProductStatusText(value);
        case 'annualInsrate':
          return `${this.formatRate(value)}%`;
        default:
          return value || '-';
      }
    },
    // 根据当前状态，计算可执行的操作
    computeStickText(v) {
      return v !== '1' ? '置顶' : '取消置顶';
    },
    computeSaleText(v) {
      return v !== '1' ? '上架' : '下架';
    },
    computeSaleClass(v) {
      return v !== '1' ? 'button--green' : 'button--red';
    },
    getStickText(v) {
      if (v === '1') {
        return <span class="button--green">是</span>;
      }
      return <span>否</span>;
    },
    getSaleText(v) {
      return v === '1' ? '上架' : '下架';
    },
    getProductStatusText(v) {
      if (v > 1) {
        return <span style="color: #999">{this.statusMap[v]}</span>;
      }
      // 若银行无“产品状态”数据，默认为“在售”
      return this.statusMap[v] || '在售';
    },
    getAlignRight(v) {
      return <div style="text-align: right;">{v}</div>;
    },
    getProductCodeText(v, row) {
      if (!v) {
        return '-';
      }
      if (!this.canViewDetail) {
        return v;
      }
      return (
        <span class="button--blue" onClick={() => this.handleDetailClick(row)}>
          {v}
        </span>
      );
    },
    // 更改上下架状态
    updateSaleStatus(data, cb, error) {
      this.$_post(this.$API.updateCDSSale, this.toggleStatus(data.isSale, data.prdCode))
        .then(cb)
        .catch(error);
    },
    // 更改置顶状态
    updateStickStatus(data, cb, error) {
      this.$_post(this.$API.updateCDSTop, this.toggleStatus(data.isTop, data.prdCode))
        .then(cb)
        .catch(error);
    },
    // 根据当前状态，计算修改状态
    toggleStatus(currentStatus, prdCode) {
      const statusMap = {
        1: '0',
        0: '1',
      };
      return {
        data: {
          prdCode,
          isTop: statusMap[currentStatus],
          isSale: statusMap[currentStatus],
          updateUserid: this.userId,
        },
      };
    },
    updateSuccess(res) {
      if (res.errorCode === this.$CODE.success) {
        this.$message.success(this.$MSG.M0108);
        this.listCDS();
      } else {
        this.$message.warning(res.errorMsg);
      }
    },
    error() {
      this.$message.error('操作失败');
    },
  },
};
